<div class="min-h-full flex flex-col" id="add-edit-contact-form">
  <app-header class="py-2">
    <div primary-slot>
      <h3 class="font-medium text-xl text-grey-blue">
        {{ isEdit ? 'Edit Contact' : 'Add Contact' }}
      </h3>
      <p class="text-xs text-grey-blue/80">
        {{
          isEdit
            ? 'Changes will take effect once the customer record is saved.'
            : 'This contact will be linked to the customer once changes are saved.'
        }}
      </p>
    </div>

    <button
      additional-slot
      id="close-modal-button"
      class="btn-primary m-0 flex items-center justify-center w-min p-1"
      (mousedown)="closeModal()"
    >
      <ion-icon class="h-5 w-5" name="close-outline"></ion-icon>
    </button>
  </app-header>

  <div class="flex-grow p-4 pt-0 overflow-y-auto">
    <form [formGroup]="newContactForm">
      <div
        class="form-input"
        [ngClass]="{
          'has-error': newContactForm.controls['name'].errors && newContactForm.controls['name'].touched,
        }"
      >
        @if (!(newContactForm.controls['name'].errors && newContactForm.controls['name'].touched)) {
          <label> Full Name </label>
        }
        @if (newContactForm.controls['name'].errors && newContactForm.controls['name'].touched) {
          <label id="contact-name-error">
            <ion-icon name="alert-circle" class="text-base"></ion-icon>
            @if (newContactForm.controls['name'].errors?.['required']) {
              <div id="required" class="error">Full Name is required</div>
            }
          </label>
        }
        <input id="contact-name" clear-input="true" formControlName="name" />
      </div>

      <div class="flex flex-col">
        <div
          class="form-input"
          [ngClass]="{
            'has-error':
              newContactForm.controls['email'].errors &&
              newContactForm.controls['email'].touched &&
              !newContactForm.controls['email'].hasError('notUnique'),
          }"
        >
          @if (
            !(showEmailDuplicate && newContactForm.controls['email'].pristine) &&
            !(newContactForm.controls['email'].errors && newContactForm.controls['email'].touched)
          ) {
            <label> Email Address </label>
          }
          @if (
            newContactForm.controls['email'].errors &&
            newContactForm.controls['email'].touched &&
            !newContactForm.controls['email'].hasError('notUnique')
          ) {
            <label id="contact-email-error">
              <ion-icon name="alert-circle" class="text-base"></ion-icon>
              @if (newContactForm.controls['email'].errors?.['required']) {
                <div id="required" class="error">Email Address is required</div>
              }
              @if (newContactForm.controls['email'].errors?.['pattern']) {
                <div id="invalid" class="error">This isn't a valid email address</div>
              }
            </label>
          }
          @if (newContactForm.controls['email'].hasError('notUnique')) {
            <label id="contact-email-error" class="text-bright-orange flex">
              <ion-icon name="warning" class="size-4 m-0 mx-1"></ion-icon>
              @if (!!emailError) {
                <span>
                  {{ emailError.split('#')[0] }}
                  @if (emailError.includes('partner application #') && emailError.split('#')[1]) {
                    <a
                      target="_blank"
                      class="btn-link"
                      tooltip="Review Partner Application"
                      [routerLink]="'/partner-applications/edit/' + emailError.split('#')[1]"
                    >
                      #{{ emailError.split('#')[1] }}
                    </a>
                  }
                  @if (emailError.includes('partner #') && emailError.split('#')[1]) {
                    <a
                      target="_blank"
                      class="btn-link"
                      tooltip="Edit Customer"
                      [routerLink]="'/customers/edit/' + emailError.split('#')[1]"
                    >
                      #{{ emailError.split('#')[1] }}
                    </a>
                  }
                </span>
              }
              @if (!emailError) {
                <span>Email already exists.</span>
              }
            </label>
          }

          <input
            id="contact-email"
            clear-input="true"
            formControlName="email"
            type="email"
            [ngClass]="{
              'border-bright-orange text-bright-orange focus:ring-bright-orange':
                newContactForm.controls['email'].hasError('notUnique'),
            }"
          />
        </div>

        <div
          class="form-input"
          [ngClass]="{
            'has-error':
              newContactForm.controls['contact_position'].errors && newContactForm.controls['contact_position'].touched,
          }"
        >
          @if (
            !(newContactForm.controls['contact_position'].errors && newContactForm.controls['contact_position'].touched)
          ) {
            <label> Position </label>
          }
          @if (
            newContactForm.controls['contact_position'].errors && newContactForm.controls['contact_position'].touched
          ) {
            <label id="contact-position-error">
              <ion-icon name="alert-circle" class="text-base"></ion-icon>
              @if (newContactForm.controls['contact_position'].errors?.['required']) {
                <div id="required" class="error">Position is required</div>
              }
            </label>
          }
          <select
            id="contact-position"
            placeholder="contact_position"
            formControlName="contact_position"
            class="form-control pr-0 truncate"
            [ngClass]="{ 'text-grey-concrete font-light text-sm': !newContactForm.controls['contact_position'].value }"
          >
            <option value="null" selected disabled>Please select...</option>
            @for (position of contactPositionOptions; track position.reference) {
              <option [value]="position.reference">
                {{ position.name }}
              </option>
            }
          </select>
        </div>
      </div>

      <div class="flex w-full gap-2">
        <div
          class="form-input w-full"
          [ngClass]="{
            'has-error':
              newContactForm.controls['telephone_number'].errors && newContactForm.controls['telephone_number'].touched,
          }"
        >
          @if (
            !(newContactForm.controls['telephone_number'].errors && newContactForm.controls['telephone_number'].touched)
          ) {
            <label> Office Number </label>
          }
          @if (
            newContactForm.controls['telephone_number'].errors && newContactForm.controls['telephone_number'].touched
          ) {
            <label>
              <ion-icon name="alert-circle" class="text-base"></ion-icon>
              @if (newContactForm.controls['telephone_number'].hasError('required')) {
                <div class="error">Office Number is required</div>
              }
              @if (newContactForm.controls['telephone_number'].hasError('mask')) {
                <div class="error">Office Number is invalid</div>
              }
              @if (newContactForm.controls['telephone_number'].hasError('min')) {
                <div class="error">Office Number is too short</div>
              }
              @if (newContactForm.controls['telephone_number'].hasError('max')) {
                <div class="error">Office Number is too long</div>
              }
            </label>
          }
          <div class="flex rounded-md shadow-sm">
            <span class="form-prefix">
              <span class="text-xl">{{ country.attributes.alpha2_code | emojiFlag }}</span>
            </span>
            <input
              id="contact-number"
              formControlName="telephone_number"
              placeholder="{{ groupType !== 'customer' && userType != 'intranet' ? '' : 'optional' }}"
              type="tel"
              class="rounded-none rounded-r-md border-l-0"
              mask="0000009999"
              prefix="+{{ country.attributes.dial_code }} "
            />
          </div>
        </div>

        <div
          class="form-input w-full"
          [ngClass]="{
            'has-error':
              newContactForm.controls['mobile_number'].errors && newContactForm.controls['mobile_number'].touched,
          }"
        >
          @if (!(newContactForm.controls['mobile_number'].errors && newContactForm.controls['mobile_number'].touched)) {
            <label> Mobile Number </label>
          }
          @if (newContactForm.controls['mobile_number'].errors && newContactForm.controls['mobile_number'].touched) {
            <label>
              <ion-icon name="alert-circle" class="text-base"></ion-icon>
              @if (newContactForm.controls['mobile_number'].hasError('required')) {
                <div class="error">Mobile Number is required</div>
              }
              @if (newContactForm.controls['mobile_number'].hasError('mask')) {
                <div class="error">Mobile Number is invalid</div>
              }
              @if (newContactForm.controls['mobile_number'].hasError('min')) {
                <div class="error">Mobile Number is too short</div>
              }
              @if (newContactForm.controls['mobile_number'].hasError('max')) {
                <div class="error">Mobile Number is too long</div>
              }
            </label>
          }
          <div class="flex rounded-md shadow-sm">
            <span class="form-prefix">
              <span class="text-xl">{{ country.attributes.alpha2_code | emojiFlag }}</span>
            </span>
            <input
              id="mobile-number"
              formControlName="mobile_number"
              placeholder="optional"
              type="tel"
              class="rounded-none rounded-r-md border-l-0"
              mask="0000009999"
              prefix="+{{ country.attributes.dial_code }} "
            />
          </div>
        </div>
      </div>

      <div
        class="form-input"
        [ngClass]="{
          'has-error':
            newContactForm.controls['contact_roles'].errors && newContactForm.controls['contact_roles'].touched,
        }"
        id="assignRoles"
      >
        <div class="rounded-xl border border-grey-concrete bg-grey-light-concrete p-3.5">
          <div class="mb-3 flex flex-col gap-1.5">
            <div class="flex flex-col gap-[0.1875rem]">
              <h2 class="m-0 text-[0.8125rem] font-semibold leading-[1.2] text-grey-blue">Role Assignment</h2>
              <p class="m-0 text-[0.6875rem] font-normal leading-[1.35] text-grey-mid">
                Choose the roles this contact should be responsible for.
              </p>
            </div>

            @if (newContactForm.controls['contact_roles'].errors && newContactForm.controls['contact_roles'].touched) {
              <div
                id="contact-role-error"
                class="inline-flex items-center gap-1.5 text-[0.6875rem] font-medium leading-[1.3] text-bright-crimson"
              >
                <ion-icon name="alert-circle" class="text-sm shrink-0"></ion-icon>
                @if (newContactForm.controls['contact_roles'].hasError('required')) {
                  <span>Assign the contact to at least one role</span>
                }
              </div>
            }
          </div>

          <div class="grid gap-2 sm:grid-cols-2">
            @for (contactRole of contactRoles; track contactRole.reference) {
              <button
                type="button"
                class="contact-role-theme btn-default m-0 !h-full flex min-h-0 w-full self-stretch flex-col gap-2 whitespace-normal rounded-lg border bg-white p-3 text-left text-inherit shadow-sm transition-colors duration-150 focus:outline-none"
                [attr.id]="'add-edit-contact-role-' + contactRole.reference"
                [attr.data-contact-role-color]="contactRole.color"
                [ngClass]="
                  newContactForm.controls['contact_roles'].value.includes(contactRole.reference)
                    ? 'border-[rgb(var(--role-rgb)/var(--role-border-alpha))] bg-[linear-gradient(150deg,rgb(var(--role-rgb)/var(--role-selected-alpha))_0%,rgb(var(--role-rgb)/0.12)_15%,rgb(var(--role-rgb)/0.05)_30%,rgb(255_255_255/0)_45%)]'
                    : 'border-grey-concrete'
                "
                (click)="toggleContactRole(contactRole.reference)"
              >
                <div class="flex items-start justify-between gap-2">
                  <div class="flex min-w-0 items-start gap-2">
                    <div
                      class="flex shrink-0 items-center justify-center text-[1.125rem]"
                      [ngClass]="
                        newContactForm.controls['contact_roles'].value.includes(contactRole.reference)
                          ? 'text-[var(--role-color)]'
                          : 'text-grey-mid'
                      "
                    >
                      <ion-icon [name]="contactRole.icon"></ion-icon>
                    </div>

                    <div class="min-w-0 flex-1">
                      <h2 class="m-0 whitespace-normal text-left text-xs font-medium leading-[1.1] text-grey-blue">
                        {{ contactRole.reference | contactRole: groupType }}
                        @if (contactRequirementsByGroupType.requiredContactRoles.includes(contactRole.reference)) {
                          <span
                            class="ml-1 inline-flex items-center rounded-full bg-[rgb(var(--role-rgb)/var(--role-chip-alpha))] px-[0.4rem] py-[0.2rem] text-[0.45rem] font-semibold uppercase leading-none tracking-[0.05em] text-grey-blue relative -top-0.5"
                            >Required</span
                          >
                        }
                      </h2>
                      <p
                        class="mt-0.5 overflow-hidden break-words text-[0.625rem] font-normal leading-[1.3] text-grey-mid line-clamp-3"
                      >
                        {{ contactRole.description }}
                      </p>
                    </div>
                  </div>

                  <ion-icon
                    [name]="
                      newContactForm.controls['contact_roles'].value.includes(contactRole.reference)
                        ? 'checkmark-circle'
                        : 'radio-button-off-outline'
                    "
                    class="mt-px shrink-0 text-[1.25rem]"
                    [class.text-primary]="
                      newContactForm.controls['contact_roles'].value.includes(contactRole.reference)
                    "
                    [class.text-grey-mid]="
                      !newContactForm.controls['contact_roles'].value.includes(contactRole.reference)
                    "
                  ></ion-icon>
                </div>
              </button>
            }
          </div>
        </div>
      </div>
    </form>
  </div>

  <footer class="flex gap-2 p-3 w-full border-t-2 border-grey-concrete justify-between items-center">
    @if (!isEdit) {
      <button id="cancel-create" class="btn-default text-sm" (click)="closeModal()">Cancel</button>
    }
    @if (isEdit) {
      <a
        id="delete-contact"
        class="btn-link-danger p-2 text-bright-crimson text-sm font-normal inline-flex h-fit items-center"
        (click)="removeContact()"
      >
        <ion-icon class="size-5 pr-2" name="person-remove-outline"></ion-icon>
        Remove Contact
      </a>
    }
    <button id="save-contact" class="btn-primary text-sm flex items-center" (click)="saveContact()">Done</button>
  </footer>
</div>
